const getFactorTextByValue = (pillarList: any, value: any) => {
  if (!Array.isArray(pillarList)) return undefined;

  const id = typeof value === 'number' ? value : value?.id;

  const factor = pillarList.find((pillar: any) => pillar.id === id);

  if (factor) return factor.name;

  if (value && typeof value === 'object' && 'title' in value) {
    return value.title ?? undefined;
  }

  return undefined;
};

export { getFactorTextByValue };
